export const metaRootSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  bgcolor: '#F8FAFD',
  borderBottom: '1px solid #E4E7EC',
  minHeight: 42,
  py: 1,
  px: 0.5
};

export const patientInfoWrapperSx = {
  display: 'flex',
  alignItems: 'flex-start',
  flex: 1
};

export const patientInfoItemSx = {
  display: 'flex',
  alignItems: 'center'
};

export const patientInfoContentSx = {
  px: 2
};

export const patientInfoLabelSx = {
  fontSize: 12,
  color: '#757575',
  lineHeight: 1
};

export const patientInfoValueSx = {
  mt: 0.5,
  fontSize: 13,
  fontWeight: 500,
  color: '#424242'
};

export const patientDividerSx = {
  borderColor: '#E5E7EB'
};

export const inviteWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  px: 3
};

export const inviteLinkSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  p: 0,
  border: 0,
  bgcolor: 'transparent',
  fontSize: '0.75rem',
  fontWeight: 500,
  color: '#424242',
  cursor: 'pointer',
  fontFamily: 'Roboto',
  textDecorationColor: '#757575'
};

export const inviteIconSx = {
  fontSize: 20,
  color: '#F44336',
  mt: '-1px'
};